import { createContext, useContext } from 'react'
import {
  InvestmentDataType,
  MetaDataResponse,
  PowerRank,
  PowerPerformanceRiveStateType,
  TaxLiabilityDataResponseType,
  PowerPerformanceForms
} from '../../types/mutual-fund-detail.types'

interface MetaDataContextType {
  data: MetaDataResponse | undefined
  loading: boolean
  isMutualFundDetailPageLoading: boolean
  isSuccess: boolean
  isError: boolean
  error: string | undefined
  isin: string
  from: string
  directFundName: string
  investmentData: InvestmentDataType | undefined
  taxLiabilityData: TaxLiabilityDataResponseType | undefined
  handleIsPowerRiveReady: (isReady: boolean) => void
  isUserElite: boolean
  handleIsUserElite: (isElite: boolean) => void
  powerForm: `${PowerPerformanceForms}` | null
  handlePowerForm: (powerForm: `${PowerPerformanceForms}`) => void
  powerRank: PowerRank
  handlePowerRank: (powerRank: PowerRank) => void
  powerPerformanceRiveState: PowerPerformanceRiveStateType
  handlePowerPerformanceRiveState: (owerPerformanceRiveState: PowerPerformanceRiveStateType) => void
  powerPerformanceRankData: any
  isPowerPerformanceRankLoading: boolean
  isPowerPerformanceRankSuccess: boolean
  isPowerPerformanceRankError: boolean
}

export const MetaDataContext = createContext<MetaDataContextType | undefined>(undefined)

export const useMetaDataContext = () => {
  const context = useContext(MetaDataContext)
  if (!context) {
    throw new Error('useMetaDataContext must be used within a MetaDataProvider')
  }
  return context
}
